import { render } from "./DownloadComments.vue?vue&type=template&id=0e63670e&scoped=true"
import script from "./DownloadComments.vue?vue&type=script&lang=js"
export * from "./DownloadComments.vue?vue&type=script&lang=js"

import "./DownloadComments.vue?vue&type=style&index=0&id=0e63670e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e63670e"]])

export default __exports__